// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AirportsReplaceController from "./airports_replace_controller"
application.register("airports-replace", AirportsReplaceController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import FancyboxController from "./fancybox_controller"
application.register("fancybox", FancyboxController)

import GtmController from "./gtm_controller"
application.register("gtm", GtmController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import OfferToggleController from "./offer_toggle_controller"
application.register("offer-toggle", OfferToggleController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import ScrollTopController from "./scroll_top_controller"
application.register("scroll-top", ScrollTopController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SeparateInvoicesController from "./separate_invoices_controller"
application.register("separate-invoices", SeparateInvoicesController)

import StickyNavbarController from "./sticky_navbar_controller"
application.register("sticky-navbar", StickyNavbarController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)
